import type { PlanBuildProgress } from '@/types/planBuildProgress';

interface PlanBuildProgressDebugOverlayProps {
  outboundProgress: PlanBuildProgress;
  className?: string;
}

/**
 * Dev/staging only: shows current stage and metadata (CTL, ATL, TSB, week).
 * Helps validate coaching logic without touching production UI.
 */
export function PlanBuildProgressDebugOverlay({
  outboundProgress,
  className,
}: PlanBuildProgressDebugOverlayProps) {
  const isDev =
    (typeof import.meta !== 'undefined' &&
      (import.meta as { env?: { DEV?: boolean } }).env?.DEV === true) ||
    false;

  if (!isDev) return null;

  const { stage, metadata } = outboundProgress;
  const parts: string[] = [];
  if (metadata?.ctl != null) parts.push(`CTL: ${metadata.ctl}`);
  if (metadata?.atl != null) parts.push(`ATL: ${metadata.atl}`);
  if (metadata?.tsb != null) parts.push(`TSB: ${metadata.tsb}`);
  if (metadata?.week != null && metadata?.total_weeks != null) {
    parts.push(`Week ${metadata.week}/${metadata.total_weeks}`);
  }

  return (
    <div
      className={className}
      role="status"
      aria-label="Debug progress overlay"
    >
      <div className="mt-2 rounded border border-amber-500/40 bg-amber-500/10 px-2 py-1.5 font-mono text-xs text-amber-700 dark:text-amber-400">
        <div className="font-semibold">[DEBUG]</div>
        <div>Stage: {stage}</div>
        {parts.length > 0 && <div>{parts.join(' | ')}</div>}
      </div>
    </div>
  );
}
